var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container content-padding" },
    [
      _vm.state === -1
        ? [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c(
                  "form",
                  {
                    attrs: { "data-vv-scope": "state-1" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.submitPrepareState("state-1")
                      }
                    }
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "กรุณากรอกเลขที่บัตรประชาชนเพื่อเข้าสู่แบบฟอร์มการสมัครค่ะ"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|length:13",
                            expression: "'required|length:13'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.idCardNumber,
                            expression: "idCardNumber"
                          }
                        ],
                        class: [
                          {
                            "form-alert": _vm.errors.has("state-1.idCardNumber")
                          },
                          "form-control",
                          "input-lg"
                        ],
                        attrs: {
                          type: "number",
                          name: "idCardNumber",
                          placeholder: "เลขที่บัตรประชาชน"
                        },
                        domProps: { value: _vm.idCardNumber },
                        on: {
                          keypress: function($event) {
                            return _vm.filterOnlyNumber($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.idCardNumber = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.has("state-1.idCardNumber")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [
                              _vm._v(
                                "\n              กรุณากรอกเลขที่บัตรประชาชนให้ครบทั้ง 13 หลัก\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.tel,
                            expression: "generalInfoSubmitData.tel"
                          }
                        ],
                        staticClass: "form-control input-lg",
                        class: { "form-alert": _vm.errors.has("state-1.tel") },
                        attrs: {
                          type: "number",
                          name: "tel",
                          placeholder:
                            "เบอร์โทร (กรอกเฉพาะตัวเลขและพิมพ์ติดกัน)"
                        },
                        domProps: { value: _vm.generalInfoSubmitData.tel },
                        on: {
                          keypress: function($event) {
                            return _vm.filterOnlyNumber($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.generalInfoSubmitData,
                              "tel",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.has("state-1.tel")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v("กรุณากรอกเบอร์โทรศัพท์")]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group form-check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.isAcceptPersonalInformation,
                            expression: "isAcceptPersonalInformation"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          "true-value": 1,
                          "false-value": 0,
                          id: "accept_protect_personal_information",
                          value: "1"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.isAcceptPersonalInformation
                          )
                            ? _vm._i(_vm.isAcceptPersonalInformation, "1") > -1
                            : _vm._q(_vm.isAcceptPersonalInformation, 1)
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.isAcceptPersonalInformation,
                              $$el = $event.target,
                              $$c = $$el.checked ? 1 : 0
                            if (Array.isArray($$a)) {
                              var $$v = "1",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.isAcceptPersonalInformation = $$a.concat(
                                    [$$v]
                                  ))
                              } else {
                                $$i > -1 &&
                                  (_vm.isAcceptPersonalInformation = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.isAcceptPersonalInformation = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(0)
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "button",
                        {
                          class: [
                            "button-large button-block",
                            _vm.isAcceptPersonalInformation ? "-cyan" : ""
                          ],
                          attrs: {
                            disabled: !_vm.isAcceptPersonalInformation,
                            type: "submit"
                          }
                        },
                        [_c("label", [_vm._v("ต่อไป")])]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group mt-5" },
                      [
                        _c(
                          "router-link",
                          {
                            staticStyle: { "text-decoration": "underline" },
                            attrs: { to: "/service-provider-privacy", tag: "a" }
                          },
                          [
                            _vm._v(
                              "นโยบายความเป็นส่วนตัวของผู้ให้บริการ Service Provider Privacy Notice"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]
        : _vm.state === 0
        ? _c("div", [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row mb-md-4" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 col-xs-12 pl-0 pr-0",
                        class: { "pr-2": !_vm.$mq.phone, "py-2": _vm.$mq.phone }
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.generalInfoSubmitData.title_th,
                                expression: "generalInfoSubmitData.title_th"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: [
                              { "form-alert": _vm.errors.has("title_th") },
                              "form-control"
                            ],
                            attrs: { name: "title_th", id: "title_th" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.generalInfoSubmitData,
                                  "title_th",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("คำนำหน้าชื่อ")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "นาย" } }, [
                              _vm._v("นาย")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "นาง" } }, [
                              _vm._v("นาง")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "นางสาว" } }, [
                              _vm._v("นางสาว")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("title_th")
                          ? _c(
                              "div",
                              { staticClass: "form-alert-text -status-alert" },
                              [_vm._v("กรุณาระบุคำนำหน้า")]
                            )
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 col-xs-12 pl-0 pr-0",
                        class: { "pr-2": !_vm.$mq.phone, "py-2": _vm.$mq.phone }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.firstname,
                              expression: "generalInfoSubmitData.firstname"
                            }
                          ],
                          staticClass: "form-control input-lg",
                          class: { "form-alert": _vm.errors.has("firstName") },
                          attrs: {
                            type: "text",
                            name: "firstName",
                            placeholder: "ชื่อ"
                          },
                          domProps: {
                            value: _vm.generalInfoSubmitData.firstname
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "firstname",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("firstName")
                          ? _c(
                              "div",
                              { staticClass: "form-alert-text -status-alert" },
                              [_vm._v("กรุณากรอกชื่อ")]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 col-xs-12 pl-0 pr-0",
                        class: { "pl-2": !_vm.$mq.phone }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.lastname,
                              expression: "generalInfoSubmitData.lastname"
                            }
                          ],
                          staticClass: "form-control input-lg",
                          class: { "form-alert": _vm.errors.has("lastName") },
                          attrs: {
                            type: "text",
                            name: "lastName",
                            placeholder: "นามสกุล"
                          },
                          domProps: {
                            value: _vm.generalInfoSubmitData.lastname
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "lastname",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("lastName")
                          ? _c(
                              "div",
                              { staticClass: "form-alert-text -status-alert" },
                              [_vm._v("กรุณากรอกนามสกุล")]
                            )
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-2 mb-1" }, [
                    _vm._v("ท่านเคยเปลี่ยน ชื่อ - นามสกุล หรือไม่?")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nameChanged,
                          expression: "nameChanged"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "nameChanged",
                        id: "nameChanged1"
                      },
                      domProps: {
                        value: 0,
                        checked: _vm._q(_vm.nameChanged, 0)
                      },
                      on: {
                        change: function($event) {
                          _vm.nameChanged = 0
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label ml-2",
                        attrs: { for: "nameChanged1" }
                      },
                      [_vm._v("\n              ไม่เคย\n            ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nameChanged,
                          expression: "nameChanged"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "nameChanged",
                        id: "nameChanged2"
                      },
                      domProps: {
                        value: 1,
                        checked: _vm._q(_vm.nameChanged, 1)
                      },
                      on: {
                        change: function($event) {
                          _vm.nameChanged = 1
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label ml-2",
                        attrs: { for: "nameChanged2" }
                      },
                      [_vm._v("\n              เคย\n            ")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.nameChanged
                    ? _c("div", { staticClass: "row mt-2 mb-4" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 col-xs-12 pl-0 pr-0",
                            class: {
                              "pr-2": !_vm.$mq.phone,
                              "py-2": _vm.$mq.phone
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.generalInfoSubmitData.prev_firstname,
                                  expression:
                                    "generalInfoSubmitData.prev_firstname"
                                }
                              ],
                              staticClass: "form-control input-lg",
                              class: {
                                "form-alert": _vm.errors.has("prevFirstName")
                              },
                              attrs: {
                                type: "text",
                                name: "prevFirstName",
                                placeholder: "ชื่อเดิม"
                              },
                              domProps: {
                                value: _vm.generalInfoSubmitData.prev_firstname
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "prev_firstname",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.has("prevFirstName")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-alert-text -status-alert"
                                  },
                                  [_vm._v("กรุณากรอกชื่อเดิม")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6 col-xs-12 pl-0 pr-0",
                            class: { "pl-2": !_vm.$mq.phone }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.generalInfoSubmitData.prev_lastname,
                                  expression:
                                    "generalInfoSubmitData.prev_lastname"
                                }
                              ],
                              staticClass: "form-control input-lg",
                              class: {
                                "form-alert": _vm.errors.has("prevLastName")
                              },
                              attrs: {
                                type: "text",
                                name: "prevLastName",
                                placeholder: "นามสกุลเดิม"
                              },
                              domProps: {
                                value: _vm.generalInfoSubmitData.prev_lastname
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "prev_lastname",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.has("prevLastName")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-alert-text -status-alert"
                                  },
                                  [_vm._v("กรุณากรอกนามสกุลเดิม")]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "email",
                        expression: "'email'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.generalInfoSubmitData.email,
                        expression: "generalInfoSubmitData.email"
                      }
                    ],
                    staticClass: "form-control input-lg",
                    class: {
                      "form-alert":
                        _vm.errors.has("email") &&
                        _vm.generalInfoSubmitData.email.trim()
                    },
                    attrs: {
                      type: "text",
                      name: "email",
                      placeholder: "อีเมล (หากไม่มีไม่ต้องกรอก)"
                    },
                    domProps: { value: _vm.generalInfoSubmitData.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.generalInfoSubmitData,
                          "email",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.has("email") &&
                  _vm.generalInfoSubmitData.email.trim()
                    ? _c(
                        "div",
                        { staticClass: "form-alert-text -status-alert" },
                        [_vm._v("อีเมลไม่ถูกต้อง")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.generalInfoSubmitData.facebook,
                        expression: "generalInfoSubmitData.facebook"
                      }
                    ],
                    staticClass: "form-control input-lg my-4",
                    attrs: {
                      type: "text",
                      name: "facebook",
                      placeholder: "ชื่อเฟสบุ๊ค (Facebook)"
                    },
                    domProps: { value: _vm.generalInfoSubmitData.facebook },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.generalInfoSubmitData,
                          "facebook",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.generalInfoSubmitData.line,
                        expression: "generalInfoSubmitData.line"
                      }
                    ],
                    staticClass: "form-control input-lg my-4",
                    attrs: {
                      type: "text",
                      name: "line",
                      placeholder: "ไอดีไลน์ (Line ID)"
                    },
                    domProps: { value: _vm.generalInfoSubmitData.line },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.generalInfoSubmitData,
                          "line",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group my-4" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3 p-0" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.birthDateData.birth_day,
                                expression: "birthDateData.birth_day"
                              }
                            ],
                            staticClass: "form-control ml-1",
                            class: {
                              "form-alert": _vm.errors.has("birth_day")
                            },
                            attrs: { id: "day", name: "birth_day" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.birthDateData,
                                  "birth_day",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("วัน")
                            ]),
                            _vm._v(" "),
                            _vm._l(31, function(day, index) {
                              return _c(
                                "option",
                                {
                                  key: "day_" + index,
                                  domProps: {
                                    value: day < 10 ? "0" + day : day.toString()
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(day) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-5" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.birthDateData.birth_month,
                                expression: "birthDateData.birth_month"
                              }
                            ],
                            staticClass: "form-control ml-1",
                            class: {
                              "form-alert": _vm.errors.has("birth_month")
                            },
                            attrs: { id: "month", name: "birth_month" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.birthDateData,
                                  "birth_month",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("เดือน")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.birthMonths, function(month, index) {
                              return _c(
                                "option",
                                {
                                  key: "month_" + index,
                                  domProps: {
                                    value:
                                      month.month < 10
                                        ? "0" + month.month
                                        : month.month.toString()
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(month.name) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4 p-0" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.birthDateData.birth_year,
                                expression: "birthDateData.birth_year"
                              }
                            ],
                            staticClass: "form-control ml-1",
                            class: {
                              "form-alert": _vm.errors.has("birth_year")
                            },
                            attrs: { id: "year", name: "birth_year" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.birthDateData,
                                  "birth_year",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("ปี (พ.ศ.)")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.birthYears, function(year) {
                              return _c(
                                "option",
                                {
                                  key: "year_" + year,
                                  domProps: { value: year }
                                },
                                [_vm._v(_vm._s(year))]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12" }, [
                        _vm.errors.has("birth_day")
                          ? _c(
                              "div",
                              { staticClass: "form-alert-text -status-alert" },
                              [_vm._v("กรุณาระบุ วันเกิด")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("birth_month")
                          ? _c(
                              "div",
                              { staticClass: "form-alert-text -status-alert" },
                              [_vm._v("กรุณาระบุ เดือนเกิด")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("birth_year")
                          ? _c(
                              "div",
                              { staticClass: "form-alert-text -status-alert" },
                              [_vm._v("กรุณาระบุ ปีเกิด")]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group my-4" }, [
                    _c("label", [_vm._v("จังหวัดที่ต้องการสมัคร")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-jumbo" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.province_id,
                              expression: "generalInfoSubmitData.province_id"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "form-alert": _vm.errors.has("province") },
                          attrs: { name: "province" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.generalInfoSubmitData,
                                  "province_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.changeProvince($event)
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("โปรดระบุ")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 1 } }, [
                            _vm._v("กรุงเทพ (ฝั่งพระนคร)")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 11 } }, [
                            _vm._v("กรุงเทพ (ฝั่งธนบุรี)")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 6 } }, [
                            _vm._v("นนทบุรี")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 7 } }, [
                            _vm._v("ปทุมธานี")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 8 } }, [
                            _vm._v("สมุทรปราการ")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 9 } }, [
                            _vm._v("สมุทรสาคร")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 10 } }, [
                            _vm._v("นครปฐม")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 2 } }, [
                            _vm._v("เชียงใหม่")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 3 } }, [
                            _vm._v("ภูเก็ต")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 4 } }, [
                            _vm._v("ชลบุรี")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 5 } }, [
                            _vm._v("ระยอง")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 0 } }, [
                            _vm._v("อื่น ๆ (โปรดระบุ)")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.generalInfoSubmitData.province_id === 0
                      ? _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.province_other,
                              expression: "generalInfoSubmitData.province_other"
                            }
                          ],
                          staticClass: "form-control input-md my-2",
                          class: {
                            "form-alert": _vm.errors.has("provinceOther")
                          },
                          attrs: {
                            type: "text",
                            name: "provinceOther",
                            placeholder: "(โปรดระบุ)"
                          },
                          domProps: {
                            value: _vm.generalInfoSubmitData.province_other
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "province_other",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.has("province")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [
                            _vm._v(
                              "\n              กรุณาเลือกจังหวัดที่ต้องการสมัคร\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.has("provinceOther")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณาระบุจังหวัด")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.generalInfoSubmitData.province_id !== 0
                    ? _c("div", { staticClass: "form-group my-4" }, [
                        _c("label", { attrs: { for: "service_districts" } }, [
                          _vm._v("อำเภอ / เขต (ที่สะดวกรับงาน)")
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "font-style": "italic" } },
                          [_vm._v("สามารถกดซ้ำเพื่อเลือกได้หลายเขต")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              ref: "service_districts",
                              staticClass: "custom-v-select",
                              class: {
                                "form-alert": _vm.errors.has(
                                  "service_districts"
                                )
                              },
                              attrs: {
                                multiple: "",
                                options: _vm.serviceDistricts,
                                placeholder: "กรุณาเลือกพื้นที่บริการ",
                                label: "name_th",
                                id: "service_districts",
                                name: "service_districts",
                                selectable: function(option) {
                                  return !(option.id == 0)
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option",
                                    fn: function(option) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(option.name_th) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2486675765
                              ),
                              model: {
                                value:
                                  _vm.generalInfoSubmitData.select_districts,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "select_districts",
                                    $$v
                                  )
                                },
                                expression:
                                  "generalInfoSubmitData.select_districts"
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.has("service_districts")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-alert-text -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      "\n                กรุณาเลือกอำเภอ / เขต (ที่สะดวกรับงาน)\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group my-4" }, [
                    _c("label", [_vm._v("เพศ")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-jumbo" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.gender,
                              expression: "generalInfoSubmitData.gender"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "form-alert": _vm.errors.has("gender") },
                          attrs: { name: "gender" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "gender",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("โปรดระบุ")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 1 } }, [
                            _vm._v("ชาย")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 2 } }, [
                            _vm._v("หญิง")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("gender")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณาเลือกเพศ")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group my-4" }, [
                    _c("label", [_vm._v("ระดับการศึกษา")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-jumbo" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.education,
                              expression: "generalInfoSubmitData.education"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "form-alert": _vm.errors.has("education") },
                          attrs: { name: "education" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "education",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("โปรดระบุ")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 1 } }, [
                            _vm._v("ประถม")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 2 } }, [
                            _vm._v("มัธยมต้น")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 3 } }, [
                            _vm._v("มัธยมปลาย")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 4 } }, [
                            _vm._v("ปวช.")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 5 } }, [
                            _vm._v("ปวส.")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 6 } }, [
                            _vm._v("ปริญญาตรี")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 7 } }, [
                            _vm._v("ปริญญาโท")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 8 } }, [
                            _vm._v("สูงกว่าปริญญาโท")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("education")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณาเลือกระดับการศึกษา")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group my-4" }, [
                    _c("label", { attrs: { for: "current_job" } }, [
                      _vm._v("งานปัจจุบัน")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.generalInfoSubmitData.current_job,
                          expression: "generalInfoSubmitData.current_job"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "form-alert": _vm.errors.has("current_job") },
                      attrs: {
                        type: "text",
                        id: "current_job",
                        name: "current_job"
                      },
                      domProps: {
                        value: _vm.generalInfoSubmitData.current_job
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.generalInfoSubmitData,
                            "current_job",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errors.has("current_job")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณากรอกงานปัจจุบัน")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "mx-auto" }, [
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            id: "reference1",
                            name: "referrence_register",
                            value: "Facebook"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "Facebook"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "Facebook"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference1" }
                          },
                          [
                            _vm._v(
                              "\n                  Facebook\n                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            name: "referrence_register",
                            type: "radio",
                            id: "reference2",
                            value: "ค้นหาผ่าน Google"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "ค้นหาผ่าน Google"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "ค้นหาผ่าน Google"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference2" }
                          },
                          [
                            _vm._v(
                              "\n                  ค้นหาผ่านกูเกิล\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.generalInfoSubmitData.reference.includes(
                          "ค้นหาผ่าน Google"
                        )
                          ? _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.referenceGoogle,
                                  expression: "referenceGoogle"
                                }
                              ],
                              staticClass: "form-control input-md my-2",
                              class: {
                                "form-alert": _vm.errors.has("referenceGoogle")
                              },
                              attrs: {
                                type: "text",
                                name: "referenceGoogle",
                                placeholder: "(โปรดระบุคำที่ใช้ค้นหา)"
                              },
                              domProps: { value: _vm.referenceGoogle },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.referenceGoogle = $event.target.value
                                }
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            id: "reference3",
                            name: "referrence_register",
                            value: "Line Job"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "Line Job"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "Line Job"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference3" }
                          },
                          [
                            _vm._v(
                              "\n                  Line Job\n                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            id: "reference4",
                            name: "referrence_register",
                            value: "Youtube"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "Youtube"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "Youtube"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference4" }
                          },
                          [
                            _vm._v(
                              "\n                  Youtube\n                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            id: "reference5",
                            name: "referrence_register",
                            value: "Twitter"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "Twitter"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "Twitter"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference5" }
                          },
                          [
                            _vm._v(
                              "\n                  Twitter\n                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            id: "reference11",
                            name: "referrence_register",
                            value: "Tiktok"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "Tiktok"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "Tiktok"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference11" }
                          },
                          [
                            _vm._v(
                              "\n                  Tiktok\n                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "referrence_register",
                            id: "reference6",
                            value: "website"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "website"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "website"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference6" }
                          },
                          [
                            _vm._v(
                              "\n                  เว็บไซต์อื่น\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.generalInfoSubmitData.reference.includes("website")
                          ? _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.referenceWebsite,
                                  expression: "referenceWebsite"
                                }
                              ],
                              staticClass: "form-control input-md my-2",
                              class: {
                                "form-alert": _vm.errors.has("referenceWebsite")
                              },
                              attrs: {
                                type: "text",
                                name: "referenceWebsite",
                                placeholder: "(โปรดระบุชื่อเว็บไซต์)"
                              },
                              domProps: { value: _vm.referenceWebsite },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.referenceWebsite = $event.target.value
                                }
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "referrence_register",
                            id: "reference10",
                            value: "finnix"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "finnix"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "finnix"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference10" }
                          },
                          [
                            _vm._v(
                              "\n                  สินเชื่อมันนิกซ์\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.generalInfoSubmitData.reference.includes("finnix")
                          ? _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.finnixDiscount,
                                  expression: "finnixDiscount"
                                }
                              ],
                              staticClass: "form-control input-md my-2",
                              class: {
                                "form-alert": _vm.errors.has("finnixDiscount")
                              },
                              attrs: {
                                type: "text",
                                name: "finnixDiscount",
                                placeholder: "(โปรดระบุโค้ดส่วนลด)"
                              },
                              domProps: { value: _vm.finnixDiscount },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.finnixDiscount = $event.target.value
                                }
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "referrence_register",
                            id: "reference7",
                            value: "friend"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "friend"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "friend"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference7" }
                          },
                          [
                            _vm._v(
                              "\n                  เพื่อนแนะนำ\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.generalInfoSubmitData.reference.includes("friend")
                          ? _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.referenceFriend,
                                  expression: "referenceFriend"
                                }
                              ],
                              staticClass: "form-control input-md my-2",
                              class: {
                                "form-alert": _vm.errors.has("referenceFriend")
                              },
                              attrs: {
                                type: "text",
                                name: "referenceFriend",
                                placeholder: "(โปรดระบุชื่อเพื่อน)"
                              },
                              domProps: { value: _vm.referenceFriend },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.referenceFriend = $event.target.value
                                }
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "referrence_register",
                            id: "reference9",
                            value: "แม่บ้านบีนีท"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "แม่บ้านบีนีท"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "แม่บ้านบีนีท"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference9" }
                          },
                          [
                            _vm._v(
                              "\n                  แม่บ้านบีนีท\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.generalInfoSubmitData.reference.includes(
                          "แม่บ้านบีนีท"
                        )
                          ? _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.referenceProfessional,
                                  expression: "referenceProfessional"
                                }
                              ],
                              staticClass: "form-control input-md my-2",
                              class: {
                                "form-alert": _vm.errors.has(
                                  "referenceProfessional"
                                )
                              },
                              attrs: {
                                type: "text",
                                name: "referenceProfessional",
                                placeholder:
                                  "(โปรดระบุชื่อหรือเบอร์โทรของคุณแม่บ้านที่แนะนำมา)"
                              },
                              domProps: { value: _vm.referenceProfessional },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.referenceProfessional =
                                    $event.target.value
                                }
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            id: "reference12",
                            name: "referrence_register",
                            value: "สำนักงานจัดหางาน"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "สำนักงานจัดหางาน"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "สำนักงานจัดหางาน"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            attrs: { for: "reference12" }
                          },
                          [
                            _vm._v(
                              "\n                  สำนักงานจัดหางาน (กรมแรงงาน)\n                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check ml-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.generalInfoSubmitData.reference,
                              expression: "generalInfoSubmitData.reference"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            id: "reference8",
                            name: "referrence_register",
                            value: "other"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.generalInfoSubmitData.reference,
                              "other"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.generalInfoSubmitData,
                                "reference",
                                "other"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label ml-2",
                            staticStyle: { width: "60px" },
                            attrs: { for: "reference8" }
                          },
                          [
                            _vm._v(
                              "\n                  อื่น ๆ\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.generalInfoSubmitData.reference.includes("other")
                          ? _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.referenceOther,
                                  expression: "referenceOther"
                                }
                              ],
                              staticClass: "form-control input-md my-2",
                              class: {
                                "form-alert": _vm.errors.has("referenceOther")
                              },
                              attrs: {
                                type: "text",
                                name: "referenceOther",
                                placeholder: "(โปรดระบุ)"
                              },
                              domProps: { value: _vm.referenceOther },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.referenceOther = $event.target.value
                                }
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.errors.has("referenceWebsite")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v("กรุณาระบุเว็บไซต์")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("referenceGoogle")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [
                              _vm._v(
                                "\n                กรุณาระบุคำที่ใช้ค้นหาใน Google\n              "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("referenceFriend")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v("กรุณาระบุชื่อเพื่อน")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("referenceProfessional")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v("กรุณาระบุแม่บ้าน")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("finnixDiscount")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v("กรุณาระบุส่วนลด")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("referenceOther")
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v("กรุณาระบุ")]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("referrence_register")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [
                            _vm._v(
                              "กรุณาเลือกช่องทางรับทราบข่าวการสมัครคุณแม่บ้านบีนีท (อย่างน้อย 1 ช่อง)"
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.service,
                            expression: "generalInfoSubmitData.service"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: "service1",
                          value: "งานทำความสะอาด"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.generalInfoSubmitData.service
                          )
                            ? _vm._i(
                                _vm.generalInfoSubmitData.service,
                                "งานทำความสะอาด"
                              ) > -1
                            : _vm.generalInfoSubmitData.service
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.generalInfoSubmitData.service,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "งานทำความสะอาด",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "service",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "service1" }
                        },
                        [
                          _vm._v(
                            "\n                งานทำความสะอาด\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.service,
                            expression: "generalInfoSubmitData.service"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: "service2",
                          value: "งานรีดผ้า"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.generalInfoSubmitData.service
                          )
                            ? _vm._i(
                                _vm.generalInfoSubmitData.service,
                                "งานรีดผ้า"
                              ) > -1
                            : _vm.generalInfoSubmitData.service
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.generalInfoSubmitData.service,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "งานรีดผ้า",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "service",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "service2" }
                        },
                        [_vm._v("\n                งานรีดผ้า\n              ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.service,
                            expression: "generalInfoSubmitData.service"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: "service3",
                          value: "เทอราปีส (นวดเพื่อสุขภาพ)"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.generalInfoSubmitData.service
                          )
                            ? _vm._i(
                                _vm.generalInfoSubmitData.service,
                                "เทอราปีส (นวดเพื่อสุขภาพ)"
                              ) > -1
                            : _vm.generalInfoSubmitData.service
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.generalInfoSubmitData.service,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "เทอราปีส (นวดเพื่อสุขภาพ)",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "service",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "service3" }
                        },
                        [
                          _vm._v(
                            "\n                เทอราปีส (นวดเพื่อสุขภาพ)\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.service,
                            expression: "generalInfoSubmitData.service"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: "service4",
                          value: "งานดูแลสวน/ตัดหญ้า"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.generalInfoSubmitData.service
                          )
                            ? _vm._i(
                                _vm.generalInfoSubmitData.service,
                                "งานดูแลสวน/ตัดหญ้า"
                              ) > -1
                            : _vm.generalInfoSubmitData.service
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.generalInfoSubmitData.service,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "งานดูแลสวน/ตัดหญ้า",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "service",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "service4" }
                        },
                        [
                          _vm._v(
                            "\n                งานดูแลสวน/ตัดหญ้า\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.service,
                            expression: "generalInfoSubmitData.service"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: "service5",
                          value: "งานผู้ฝึกสอนโยคะ"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.generalInfoSubmitData.service
                          )
                            ? _vm._i(
                                _vm.generalInfoSubmitData.service,
                                "งานผู้ฝึกสอนโยคะ"
                              ) > -1
                            : _vm.generalInfoSubmitData.service
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.generalInfoSubmitData.service,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "งานผู้ฝึกสอนโยคะ",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.generalInfoSubmitData,
                                    "service",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.generalInfoSubmitData,
                                "service",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "service5" }
                        },
                        [
                          _vm._v(
                            "\n                งานผู้ฝึกสอนโยคะ\n              "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(6),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.interest_regular_cleaning,
                            expression: "interest_regular_cleaning"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "interest_regular_cleaning",
                          id: "interest_regular_cleaning1"
                        },
                        domProps: {
                          value: 1,
                          checked: _vm._q(_vm.interest_regular_cleaning, 1)
                        },
                        on: {
                          change: function($event) {
                            _vm.interest_regular_cleaning = 1
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "interest_regular_cleaning1" }
                        },
                        [_vm._v("\n                สนใจ\n              ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.interest_regular_cleaning,
                            expression: "interest_regular_cleaning"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "interest_regular_cleaning",
                          id: "interest_regular_cleaning2"
                        },
                        domProps: {
                          value: 0,
                          checked: _vm._q(_vm.interest_regular_cleaning, 0)
                        },
                        on: {
                          change: function($event) {
                            _vm.interest_regular_cleaning = 0
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "interest_regular_cleaning2" }
                        },
                        [_vm._v("\n                ไม่สนใจ\n              ")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("interest_regular_cleaning")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [
                            _vm._v(
                              "\n              กรุณากรอกข้อมูลให้ครบถ้วน\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.been_cleaner,
                            expression: "been_cleaner"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "have_to_cleaner",
                          id: "have_to_cleaner1"
                        },
                        domProps: {
                          value: 1,
                          checked: _vm._q(_vm.been_cleaner, 1)
                        },
                        on: {
                          change: function($event) {
                            _vm.been_cleaner = 1
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "have_to_cleaner1" }
                        },
                        [_vm._v("\n                เคย\n              ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.been_cleaner,
                            expression: "been_cleaner"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "have_to_cleaner",
                          id: "have_to_cleaner2"
                        },
                        domProps: {
                          value: 0,
                          checked: _vm._q(_vm.been_cleaner, 0)
                        },
                        on: {
                          change: function($event) {
                            _vm.been_cleaner = 0
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "have_to_cleaner2" }
                        },
                        [_vm._v("\n                ไม่เคย\n              ")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("have_to_cleaner")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน\n            ")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(8),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.smoking,
                            expression: "generalInfoSubmitData.smoking"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "smoking",
                          id: "smoking1"
                        },
                        domProps: {
                          value: 1,
                          checked: _vm._q(_vm.generalInfoSubmitData.smoking, 1)
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.generalInfoSubmitData,
                              "smoking",
                              1
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "smoking1" }
                        },
                        [_vm._v("\n                สูบ\n              ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.smoking,
                            expression: "generalInfoSubmitData.smoking"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "smoking",
                          id: "smoking2"
                        },
                        domProps: {
                          value: 0,
                          checked: _vm._q(_vm.generalInfoSubmitData.smoking, 0)
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.generalInfoSubmitData,
                              "smoking",
                              0
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "smoking2" }
                        },
                        [_vm._v("\n                ไม่สูบ\n              ")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("smoking")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน\n            ")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(9),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.drink_alcohol,
                            expression: "generalInfoSubmitData.drink_alcohol"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "drink_alcohol",
                          id: "drink_alcohol1"
                        },
                        domProps: {
                          value: 1,
                          checked: _vm._q(
                            _vm.generalInfoSubmitData.drink_alcohol,
                            1
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.generalInfoSubmitData,
                              "drink_alcohol",
                              1
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "drink_alcohol1" }
                        },
                        [
                          _vm._v(
                            "\n                ดื่มเป็นประจำ\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.drink_alcohol,
                            expression: "generalInfoSubmitData.drink_alcohol"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "drink_alcohol",
                          id: "drink_alcohol2"
                        },
                        domProps: {
                          value: 2,
                          checked: _vm._q(
                            _vm.generalInfoSubmitData.drink_alcohol,
                            2
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.generalInfoSubmitData,
                              "drink_alcohol",
                              2
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "drink_alcohol2" }
                        },
                        [
                          _vm._v(
                            "\n                ไม่บ่อย (นานๆครั้ง)\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.generalInfoSubmitData.drink_alcohol,
                            expression: "generalInfoSubmitData.drink_alcohol"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "drink_alcohol",
                          id: "drink_alcohol3"
                        },
                        domProps: {
                          value: 3,
                          checked: _vm._q(
                            _vm.generalInfoSubmitData.drink_alcohol,
                            3
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.generalInfoSubmitData,
                              "drink_alcohol",
                              3
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "drink_alcohol3" }
                        },
                        [
                          _vm._v(
                            "\n                ไม่ดื่มแอลกอฮอล์\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("drink_alcohol")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน\n            ")]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button-large button-block -cyan",
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        click: function($event) {
                          return _vm.submitInformation()
                        }
                      }
                    },
                    [_c("label", [_vm._v("ต่อไป")])]
                  )
                ])
              ])
            ])
          ])
        : _vm.state === 1
        ? _c("div", [
            _vm._m(10),
            _vm._v(" "),
            _vm._m(11),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_type,
                        expression: "questionnaireSubmitData.exp_type"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expType", id: "expType1" },
                    domProps: {
                      value: 1,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_type, 1)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_type",
                          1
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expType1" }
                    },
                    [_vm._v("\n            เคย แบบเต็มเวลา\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_type,
                        expression: "questionnaireSubmitData.exp_type"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expType", id: "expType2" },
                    domProps: {
                      value: 2,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_type, 2)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_type",
                          2
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expType2" }
                    },
                    [_vm._v("\n            เคย แบบพาร์ทไทม์\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_type,
                        expression: "questionnaireSubmitData.exp_type"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expType", id: "expType3" },
                    domProps: {
                      value: 0,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_type, 0)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_type",
                          0
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expType3" }
                    },
                    [_vm._v("\n            ไม่เคย\n          ")]
                  )
                ]),
                _vm._v(" "),
                _vm.errors.has("expType")
                  ? _c(
                      "div",
                      { staticClass: "form-alert-text -status-alert" },
                      [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm._m(12),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_year,
                        expression: "questionnaireSubmitData.exp_year"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expYear", id: "expYear1" },
                    domProps: {
                      value: 1,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_year, 1)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_year",
                          1
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expYear1" }
                    },
                    [_vm._v("\n            น้อยกว่า 1 ปี\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_year,
                        expression: "questionnaireSubmitData.exp_year"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expYear", id: "expYear2" },
                    domProps: {
                      value: 2,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_year, 2)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_year",
                          2
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expYear2" }
                    },
                    [_vm._v("\n            1 - 2 ปี\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_year,
                        expression: "questionnaireSubmitData.exp_year"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expYear", id: "expYear3" },
                    domProps: {
                      value: 3,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_year, 3)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_year",
                          3
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expYear3" }
                    },
                    [_vm._v("\n            3 - 4 ปี\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_year,
                        expression: "questionnaireSubmitData.exp_year"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expYear", id: "expYear4" },
                    domProps: {
                      value: 4,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_year, 4)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_year",
                          4
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expYear4" }
                    },
                    [_vm._v("\n            5 ปีขึ้นไป\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_year,
                        expression: "questionnaireSubmitData.exp_year"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "radio", name: "expYear", id: "expYear5" },
                    domProps: {
                      value: 0,
                      checked: _vm._q(_vm.questionnaireSubmitData.exp_year, 0)
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "exp_year",
                          0
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expYear5" }
                    },
                    [_vm._v("\n            ไม่มีประสบการณ์\n          ")]
                  )
                ]),
                _vm._v(" "),
                _vm.errors.has("expYear")
                  ? _c(
                      "div",
                      { staticClass: "form-alert-text -status-alert" },
                      [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm._m(13),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_place_type,
                        expression: "questionnaireSubmitData.exp_place_type"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "expPlaceType1",
                      value: "คอนโด/อพาร์ทเมนท์"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.exp_place_type
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.exp_place_type,
                            "คอนโด/อพาร์ทเมนท์"
                          ) > -1
                        : _vm.questionnaireSubmitData.exp_place_type
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.exp_place_type,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "คอนโด/อพาร์ทเมนท์",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.questionnaireSubmitData,
                            "exp_place_type",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expPlaceType1" }
                    },
                    [_vm._v("\n            คอนโด / อพาร์ทเมนท์\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_place_type,
                        expression: "questionnaireSubmitData.exp_place_type"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "expPlaceType2",
                      value: "บ้าน/ทาวน์โฮม"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.exp_place_type
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.exp_place_type,
                            "บ้าน/ทาวน์โฮม"
                          ) > -1
                        : _vm.questionnaireSubmitData.exp_place_type
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.exp_place_type,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "บ้าน/ทาวน์โฮม",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.questionnaireSubmitData,
                            "exp_place_type",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expPlaceType2" }
                    },
                    [_vm._v("\n            บ้าน / ทาวน์โฮม\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_place_type,
                        expression: "questionnaireSubmitData.exp_place_type"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "expPlaceType3",
                      value: "โรงแรม/รีสอร์ท"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.exp_place_type
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.exp_place_type,
                            "โรงแรม/รีสอร์ท"
                          ) > -1
                        : _vm.questionnaireSubmitData.exp_place_type
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.exp_place_type,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "โรงแรม/รีสอร์ท",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.questionnaireSubmitData,
                            "exp_place_type",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expPlaceType3" }
                    },
                    [_vm._v("\n            โรงแรม / รีสอร์ท\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_place_type,
                        expression: "questionnaireSubmitData.exp_place_type"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "expPlaceType4",
                      value: "สำนักงาน"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.exp_place_type
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.exp_place_type,
                            "สำนักงาน"
                          ) > -1
                        : _vm.questionnaireSubmitData.exp_place_type
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.exp_place_type,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "สำนักงาน",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.questionnaireSubmitData,
                            "exp_place_type",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expPlaceType4" }
                    },
                    [_vm._v("\n            สำนักงาน\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.exp_place_type,
                        expression: "questionnaireSubmitData.exp_place_type"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "expPlaceType5",
                      value: "other"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.exp_place_type
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.exp_place_type,
                            "other"
                          ) > -1
                        : _vm.questionnaireSubmitData.exp_place_type
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.exp_place_type,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "other",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "exp_place_type",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.questionnaireSubmitData,
                            "exp_place_type",
                            $$c
                          )
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      staticStyle: { width: "60px" },
                      attrs: { for: "expPlaceType5" }
                    },
                    [_vm._v("\n            อื่น ๆ\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.questionnaireSubmitData.exp_place_type.includes("other")
                    ? _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.expPlaceTypeOther,
                            expression: "expPlaceTypeOther"
                          }
                        ],
                        staticClass: "form-control input-md my-2",
                        class: {
                          "form-alert": _vm.errors.has("expPlaceTypeOther")
                        },
                        attrs: {
                          type: "text",
                          name: "expPlaceTypeOther",
                          placeholder: "(โปรดระบุ)"
                        },
                        domProps: { value: _vm.expPlaceTypeOther },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.expPlaceTypeOther = $event.target.value
                          }
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.errors.has("expPlaceTypeOther")
                  ? _c(
                      "div",
                      { staticClass: "form-alert-text -status-alert" },
                      [_vm._v("กรุณาระบุประเภทที่พัก")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm._m(14),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.expCompanyBool,
                        expression: "expCompanyBool"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "expCompanyBool",
                      id: "expCompanyBool1"
                    },
                    domProps: {
                      value: 1,
                      checked: _vm._q(_vm.expCompanyBool, 1)
                    },
                    on: {
                      change: function($event) {
                        _vm.expCompanyBool = 1
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expCompanyBool1" }
                    },
                    [_vm._v("\n            เคย\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.expCompanyBool
                    ? _c("div", [
                        _c("div", { staticClass: "form-check ml-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionnaireSubmitData.exp_company,
                                expression:
                                  "questionnaireSubmitData.exp_company"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: "expCompany",
                              id: "expCompany1",
                              value: "Seekster"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.questionnaireSubmitData.exp_company,
                                "Seekster"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.questionnaireSubmitData,
                                  "exp_company",
                                  "Seekster"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-2",
                              attrs: { for: "expCompany1" }
                            },
                            [
                              _vm._v(
                                "\n                Seekster\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check ml-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionnaireSubmitData.exp_company,
                                expression:
                                  "questionnaireSubmitData.exp_company"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: "expCompany",
                              id: "expCompany2",
                              value: "Fixzy"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.questionnaireSubmitData.exp_company,
                                "Fixzy"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.questionnaireSubmitData,
                                  "exp_company",
                                  "Fixzy"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-2",
                              attrs: { for: "expCompany2" }
                            },
                            [_vm._v("\n                Fixzy\n              ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check ml-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionnaireSubmitData.exp_company,
                                expression:
                                  "questionnaireSubmitData.exp_company"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: "expCompany",
                              id: "expCompany3",
                              value: "ServisHero"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.questionnaireSubmitData.exp_company,
                                "ServisHero"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.questionnaireSubmitData,
                                  "exp_company",
                                  "ServisHero"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-2",
                              attrs: { for: "expCompany3" }
                            },
                            [
                              _vm._v(
                                "\n                ServisHero\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check ml-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionnaireSubmitData.exp_company,
                                expression:
                                  "questionnaireSubmitData.exp_company"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: "expCompany",
                              id: "expCompany4",
                              value: "KnockDoor"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.questionnaireSubmitData.exp_company,
                                "KnockDoor"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.questionnaireSubmitData,
                                  "exp_company",
                                  "KnockDoor"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-2",
                              attrs: { for: "expCompany4" }
                            },
                            [
                              _vm._v(
                                "\n                KnockDoor\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check ml-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionnaireSubmitData.exp_company,
                                expression:
                                  "questionnaireSubmitData.exp_company"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: "expCompany",
                              id: "expCompany4",
                              value: "bTaskee"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.questionnaireSubmitData.exp_company,
                                "bTaskee"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.questionnaireSubmitData,
                                  "exp_company",
                                  "bTaskee"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-2",
                              attrs: { for: "expCompany6" }
                            },
                            [
                              _vm._v(
                                "\n                bTaskee\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check ml-3" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionnaireSubmitData.exp_company,
                                expression:
                                  "questionnaireSubmitData.exp_company"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              name: "expCompany",
                              id: "expCompany5",
                              value: "other"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.questionnaireSubmitData.exp_company,
                                "other"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.questionnaireSubmitData,
                                  "exp_company",
                                  "other"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label ml-2",
                              attrs: { for: "expCompany5" }
                            },
                            [_vm._v("\n                อื่น ๆ\n              ")]
                          ),
                          _vm._v(" "),
                          _vm.questionnaireSubmitData.exp_company === "other"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.expCompanyOther,
                                    expression: "expCompanyOther"
                                  }
                                ],
                                staticClass: "form-control input-md my-2",
                                class: {
                                  "form-alert": _vm.errors.has(
                                    "expCompanyOther"
                                  )
                                },
                                attrs: {
                                  type: "text",
                                  name: "expCompanyOther",
                                  placeholder: "(โปรดระบุ)"
                                },
                                domProps: { value: _vm.expCompanyOther },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.expCompanyOther = $event.target.value
                                  }
                                }
                              })
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.expCompanyBool,
                        expression: "expCompanyBool"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "expCompanyBool",
                      id: "expCompanyBool2"
                    },
                    domProps: {
                      value: 0,
                      checked: _vm._q(_vm.expCompanyBool, 0)
                    },
                    on: {
                      change: function($event) {
                        _vm.expCompanyBool = 0
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "expCompanyBool2" }
                    },
                    [_vm._v("\n            ไม่เคย\n          ")]
                  )
                ]),
                _vm._v(" "),
                _vm.errors.has("expCompanyBool")
                  ? _c(
                      "div",
                      { staticClass: "form-alert-text -status-alert" },
                      [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.errors.has("expCompany")
                  ? _c(
                      "div",
                      { staticClass: "form-alert-text -status-alert" },
                      [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.errors.has("expCompanyOther")
                  ? _c(
                      "div",
                      { staticClass: "form-alert-text -status-alert" },
                      [_vm._v("กรุณาระบุชื่อบริษัทหรือแอพ\n        ")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm._m(15),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_period,
                        expression: "questionnaireSubmitData.work_period"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "workPeriod",
                      id: "workPeriod1"
                    },
                    domProps: {
                      value: 1,
                      checked: _vm._q(
                        _vm.questionnaireSubmitData.work_period,
                        1
                      )
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "work_period",
                          1
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "workPeriod1" }
                    },
                    [
                      _vm._v(
                        "\n            สะดวกช่วง วันจันทร์ - วันศุกร์\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_period,
                        expression: "questionnaireSubmitData.work_period"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "workPeriod",
                      id: "workPeriod2"
                    },
                    domProps: {
                      value: 2,
                      checked: _vm._q(
                        _vm.questionnaireSubmitData.work_period,
                        2
                      )
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "work_period",
                          2
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "workPeriod2" }
                    },
                    [
                      _vm._v(
                        "\n            สะดวกช่วง วันเสาร์ - วันอาทิตย์\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_period,
                        expression: "questionnaireSubmitData.work_period"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "workPeriod",
                      id: "workPeriod3"
                    },
                    domProps: {
                      value: 3,
                      checked: _vm._q(
                        _vm.questionnaireSubmitData.work_period,
                        3
                      )
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.questionnaireSubmitData,
                          "work_period",
                          3
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "workPeriod3" }
                    },
                    [_vm._v("\n            สะดวกทุกวัน\n          ")]
                  )
                ]),
                _vm._v(" "),
                _vm.errors.has("workPeriod")
                  ? _c(
                      "div",
                      { staticClass: "form-alert-text -status-alert" },
                      [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm._m(16),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "language1", value: "ไทย" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(_vm.questionnaireSubmitData.language, "ไทย") >
                          -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "ไทย",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language1" }
                    },
                    [_vm._v("\n            ไทย\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language2",
                      value: "อังกฤษ"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "อังกฤษ"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "อังกฤษ",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language2" }
                    },
                    [_vm._v("\n            อังกฤษ\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "language3", value: "จีน" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(_vm.questionnaireSubmitData.language, "จีน") >
                          -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "จีน",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language3" }
                    },
                    [_vm._v("\n            จีน\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language4",
                      value: "ญี่ปุ่น"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "ญี่ปุ่น"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "ญี่ปุ่น",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language4" }
                    },
                    [_vm._v("\n            ญี่ปุ่น\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language5",
                      value: "เยอรมัน"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "เยอรมัน"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "เยอรมัน",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language5" }
                    },
                    [_vm._v("\n            เยอรมัน\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language6",
                      value: "รัสเซีย"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "รัสเซีย"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "รัสเซีย",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language6" }
                    },
                    [_vm._v("\n            รัสเซีย\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language7",
                      value: "ฝรั่งเศส"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "ฝรั่งเศส"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "ฝรั่งเศส",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language7" }
                    },
                    [_vm._v("\n            ฝรั่งเศส\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language8",
                      value: "เกาหลี"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "เกาหลี"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "เกาหลี",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language8" }
                    },
                    [_vm._v("\n            เกาหลี\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language9",
                      value: "อินเดีย"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "อินเดีย"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "อินเดีย",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "language9" }
                    },
                    [_vm._v("\n            อินเดีย\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.language,
                        expression: "questionnaireSubmitData.language"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "language10",
                      value: "other"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.language
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.language,
                            "other"
                          ) > -1
                        : _vm.questionnaireSubmitData.language
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.language,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "other",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "language",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "language", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      staticStyle: { width: "60px" },
                      attrs: { for: "language10" }
                    },
                    [_vm._v("\n            อื่น ๆ\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.questionnaireSubmitData.language.includes("other")
                    ? _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.languageOther,
                            expression: "languageOther"
                          }
                        ],
                        staticClass: "form-control input-md my-2",
                        class: {
                          "form-alert": _vm.errors.has("languageOther")
                        },
                        attrs: {
                          type: "text",
                          name: "languageOther",
                          placeholder: "(โปรดระบุ)"
                        },
                        domProps: { value: _vm.languageOther },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.languageOther = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("languageOther")
                    ? _c(
                        "div",
                        { staticClass: "form-alert-text -status-alert" },
                        [_vm._v("กรุณาระบุภาษา")]
                      )
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(17),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_exp,
                        expression: "questionnaireSubmitData.work_exp"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "work_exp1",
                      value: "งานเลี้ยงเด็ก"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.work_exp
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.work_exp,
                            "งานเลี้ยงเด็ก"
                          ) > -1
                        : _vm.questionnaireSubmitData.work_exp
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.work_exp,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "งานเลี้ยงเด็ก",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "work_exp", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "work_exp1" }
                    },
                    [_vm._v("\n            งานเลี้ยงเด็ก\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_exp,
                        expression: "questionnaireSubmitData.work_exp"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "work_exp2",
                      value: "ดูแลผู้สูงอายุ"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.work_exp
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.work_exp,
                            "ดูแลผู้สูงอายุ"
                          ) > -1
                        : _vm.questionnaireSubmitData.work_exp
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.work_exp,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "ดูแลผู้สูงอายุ",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "work_exp", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "work_exp2" }
                    },
                    [_vm._v("\n            ดูแลผู้สูงอายุ\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_exp,
                        expression: "questionnaireSubmitData.work_exp"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "work_exp3",
                      value: "ดูแลผู้ป่วย"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.work_exp
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.work_exp,
                            "ดูแลผู้ป่วย"
                          ) > -1
                        : _vm.questionnaireSubmitData.work_exp
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.work_exp,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "ดูแลผู้ป่วย",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "work_exp", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "work_exp3" }
                    },
                    [_vm._v("\n            ดูแลผู้ป่วย\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_exp,
                        expression: "questionnaireSubmitData.work_exp"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "work_exp4",
                      value: "แม่บ้านทำอาหาร"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.work_exp
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.work_exp,
                            "แม่บ้านทำอาหาร"
                          ) > -1
                        : _vm.questionnaireSubmitData.work_exp
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.work_exp,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "แม่บ้านทำอาหาร",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "work_exp", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      attrs: { for: "work_exp4" }
                    },
                    [_vm._v("\n            แม่บ้านทำอาหาร\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check ml-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionnaireSubmitData.work_exp,
                        expression: "questionnaireSubmitData.work_exp"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "work_exp5",
                      value: "other"
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.questionnaireSubmitData.work_exp
                      )
                        ? _vm._i(
                            _vm.questionnaireSubmitData.work_exp,
                            "other"
                          ) > -1
                        : _vm.questionnaireSubmitData.work_exp
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.questionnaireSubmitData.work_exp,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "other",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.questionnaireSubmitData,
                                "work_exp",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.questionnaireSubmitData, "work_exp", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label ml-2",
                      staticStyle: { width: "60px" },
                      attrs: { for: "work_exp5" }
                    },
                    [_vm._v("\n            อื่น ๆ\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.questionnaireSubmitData.work_exp.includes("other")
                    ? _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.workExpOther,
                            expression: "workExpOther"
                          }
                        ],
                        staticClass: "form-control input-md my-2",
                        class: { "form-alert": _vm.errors.has("workExpOther") },
                        attrs: {
                          type: "text",
                          name: "workExpOther",
                          placeholder: "(โปรดระบุ)"
                        },
                        domProps: { value: _vm.workExpOther },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.workExpOther = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("workExpOther")
                    ? _c(
                        "div",
                        { staticClass: "form-alert-text -status-alert" },
                        [_vm._v("กรุณาระบุประสบการณ์การทำงาน")]
                      )
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(18),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("label", [_vm._v("8.1 รถยนต์")]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionnaireSubmitData.driving_car,
                            expression: "questionnaireSubmitData.driving_car"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "driving_exp1",
                          value: "ขับได้มีใบขับขี่",
                          name: "driving_car"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionnaireSubmitData.driving_car,
                            "ขับได้มีใบขับขี่"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.questionnaireSubmitData,
                              "driving_car",
                              "ขับได้มีใบขับขี่"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "driving_exp1" }
                        },
                        [_vm._v("ขับได้มีใบขับขี่")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionnaireSubmitData.driving_car,
                            expression: "questionnaireSubmitData.driving_car"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "driving_exp2",
                          value: "ขับได้ไม่มีใบขับขี่",
                          name: "driving_car"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionnaireSubmitData.driving_car,
                            "ขับได้ไม่มีใบขับขี่"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.questionnaireSubmitData,
                              "driving_car",
                              "ขับได้ไม่มีใบขับขี่"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "driving_exp2" }
                        },
                        [_vm._v("ขับได้ไม่มีใบขับขี่")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionnaireSubmitData.driving_car,
                            expression: "questionnaireSubmitData.driving_car"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "driving_exp3",
                          value: "ขับไม่ได้",
                          name: "driving_car"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionnaireSubmitData.driving_car,
                            "ขับไม่ได้"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.questionnaireSubmitData,
                              "driving_car",
                              "ขับไม่ได้"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "driving_exp3" }
                        },
                        [_vm._v("ขับไม่ได้")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("driving_car")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน")]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("label", [_vm._v("8.2 รถจักรยานยนต์")]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionnaireSubmitData.driving_motorcycle,
                            expression:
                              "questionnaireSubmitData.driving_motorcycle"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "driving_exp4",
                          value: "ขับได้มีใบขับขี่",
                          name: "driving_motorcycle"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionnaireSubmitData.driving_motorcycle,
                            "ขับได้มีใบขับขี่"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.questionnaireSubmitData,
                              "driving_motorcycle",
                              "ขับได้มีใบขับขี่"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "driving_exp4" }
                        },
                        [_vm._v("ขับได้มีใบขับขี่")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionnaireSubmitData.driving_motorcycle,
                            expression:
                              "questionnaireSubmitData.driving_motorcycle"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "driving_exp5",
                          value: "ขับได้ไม่มีใบขับขี่",
                          name: "driving_motorcycle"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionnaireSubmitData.driving_motorcycle,
                            "ขับได้ไม่มีใบขับขี่"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.questionnaireSubmitData,
                              "driving_motorcycle",
                              "ขับได้ไม่มีใบขับขี่"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "driving_exp5" }
                        },
                        [_vm._v("ขับได้ไม่มีใบขับขี่")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check ml-3" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionnaireSubmitData.driving_motorcycle,
                            expression:
                              "questionnaireSubmitData.driving_motorcycle"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          id: "driving_exp6",
                          value: "ขับไม่ได้",
                          name: "driving_motorcycle"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionnaireSubmitData.driving_motorcycle,
                            "ขับไม่ได้"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.questionnaireSubmitData,
                              "driving_motorcycle",
                              "ขับไม่ได้"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-2",
                          attrs: { for: "driving_exp6" }
                        },
                        [_vm._v("ขับไม่ได้")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.has("driving_motorcycle")
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v("กรุณากรอกข้อมูลให้ครบถ้วน")]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button-large button-block -cyan",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submitQuestionnaire()
                        }
                      }
                    },
                    [_c("label", [_vm._v("ต่อไป")])]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === 2
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-8 col-xs-12 mx-auto" },
                [
                  _vm.generalInfoSubmitData.type !== 2
                    ? [_vm._m(19), _vm._v(" "), _vm._m(20)]
                    : [_vm._m(21)],
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "mt-4 text-center",
                      staticStyle: { "font-weight": "bold" }
                    },
                    [_vm._v("คุณได้กรอกข้อมูลครบถ้วนแล้วค่ะ")]
                  ),
                  _vm._v(" "),
                  _vm.generalInfoSubmitData.type !== 2
                    ? [
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v(
                            "ขั้นตอนต่อไป กรุณาเลือกศูนย์ฝึกอบรมและวันที่ต้องการเข้าอบรม"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "select-jumbo" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedTrainingCenter,
                                  expression: "selectedTrainingCenter"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "form-alert": _vm.errors.has("trainingCenter")
                              },
                              attrs: { name: "trainingCenter" },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedTrainingCenter = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function($event) {
                                    return _vm.selectTrainingCenterHandler()
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("เลือกศูนย์ฝึกอบรม")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.trainingCenters, function(
                                trainingCenter,
                                index
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: trainingCenter }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(trainingCenter.name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm.selectedTrainingCenter
                          ? _c("div", { staticClass: "select-jumbo mt-3" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedTrainingDate,
                                      expression: "selectedTrainingDate"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "form-alert": _vm.errors.has("trainingDate")
                                  },
                                  attrs: { name: "trainingDate" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.selectedTrainingDate = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("เลือกวันที่อบรม")
                                  ]),
                                  _vm._v(" "),
                                  _vm.provinceId === 2
                                    ? _vm._l(_vm.trainingDates, function(
                                        date,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            attrs: {
                                              disabled: Number(date.full) === 1
                                            },
                                            domProps: { value: date }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("prettyOnlyDate")(
                                                  date.date
                                                )
                                              ) +
                                                " - " +
                                                _vm._s(
                                                  _vm._f("prettyOnlyDate")(
                                                    _vm.getTomorrowDate(
                                                      date.date
                                                    )
                                                  )
                                                ) +
                                                " (อบรม 1 วัน) เวลา " +
                                                _vm._s(date.start_time) +
                                                " - " +
                                                _vm._s(date.end_time) +
                                                " " +
                                                _vm._s(
                                                  Number(date.full) === 1
                                                    ? "(เต็ม)"
                                                    : Number(date.remain) > 0
                                                    ? "(ว่าง\n                " +
                                                      date.remain +
                                                      " ที่)"
                                                    : ""
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      })
                                    : _vm._l(_vm.trainingDates, function(
                                        date,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            attrs: {
                                              disabled: Number(date.full) === 1
                                            },
                                            domProps: { value: date }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("prettyOnlyDate")(
                                                  date.date
                                                )
                                              ) +
                                                " " +
                                                _vm._s(date.start_time) +
                                                " - " +
                                                _vm._s(date.end_time) +
                                                " " +
                                                _vm._s(
                                                  Number(date.full) === 1
                                                    ? "(เต็ม)"
                                                    : Number(date.remain) > 0
                                                    ? "(ว่าง\n                " +
                                                      date.remain +
                                                      " ที่)"
                                                    : ""
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      })
                                ],
                                2
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h3", { staticClass: "mt-4" }, [
                          _vm._v("สถานที่ฝึกอบรม")
                        ]),
                        _vm._v(" "),
                        _vm.selectedTrainingCenter
                          ? _c("div", [
                              _c(
                                "p",
                                { staticStyle: { "white-space": "pre-wrap" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.selectedTrainingCenter.address)
                                  )
                                ]
                              )
                            ])
                          : _c("div", [
                              _c("span", { staticClass: "text-mute" }, [
                                _vm._v("กรุณาเลือกสถานที่ฝึกอบรม")
                              ])
                            ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-muted mt-1" }, [
                          _vm._v(
                            "\n            * การอบรมแต่ละรอบมีการจำกัดจำนวนที่นั่ง ทางบริษัทขอให้สิทธิ์ตามลำดับผู้สมัครที่ยืนยันการจองเข้าอบรมค่ะ\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-muted mt-2" }, [
                          _vm._v(
                            "\n            ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครที่"
                          ),
                          _c("br"),
                          _vm._v("\n            - เชียงใหม่ติดต่อ "),
                          _c("a", { attrs: { href: "tel:0625688997" } }, [
                            _vm._v("062-5688997")
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n            - กรุงเทพ ปริมณฑล และจังหวัดอื่น ๆ ติดต่อ "
                          ),
                          _c("a", { attrs: { href: "tel:0649952288" } }, [
                            _vm._v("064-9952288")
                          ]),
                          _vm._v(" หรือ "),
                          _c("a", { attrs: { href: "tel:0622917700" } }, [
                            _vm._v("062-2917700")
                          ]),
                          _c("br"),
                          _c("br"),
                          _vm._v("\n            Line ID: "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://line.me/R/ti/p/%40beneatpro"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openLineRegister.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [_vm._v("@BeNeatPro")]
                          )
                        ])
                      ]
                    : [
                        _c("p", { staticClass: "text-muted mt-2" }, [
                          _vm._v(
                            "\n            ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครคุณแม่บ้านประจำ"
                          ),
                          _c("br"),
                          _vm._v("\n            MIKU Agency "),
                          _c("a", { attrs: { href: "tel:0632970492" } }, [
                            _vm._v("063-297-0492")
                          ]),
                          _vm._v(", "),
                          _c("a", { attrs: { href: "tel:0621966190" } }, [
                            _vm._v("062-196-6190")
                          ]),
                          _c("br"),
                          _vm._v("\n            Line ID: "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://line.me/R/ti/p/@164uxerr"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openLineRegister.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [_vm._v("@jobmaid")]
                          )
                        ])
                      ]
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-md-8 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button-large button-block -cyan",
                      on: {
                        click: function($event) {
                          return _vm.submitTrainingDate()
                        }
                      }
                    },
                    [_c("label", [_vm._v("ต่อไป")])]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === 3
        ? _c("div", [
            _vm._m(22),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-8 col-xs-12 mx-auto" }, [
                _c("h3", { staticClass: "text-left" }, [
                  _vm._v(
                    "กรุณาโอนชำระค่าจองที่นั่งเข้าอบรม 299 บาท (ส่วนที่เหลือชำระเพิ่มในวันอบรมงานค่ะ)\n          และกรุณาแนบหลักฐานด้านล่าง"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-left" }, [
                  _vm._v(
                    "\n          หากขัดข้องกรุณาติดต่อเจ้าหน้าที่ฝ่ายรับสมัครที่ไลน์ "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "https://line.me/R/ti/p/%40beneatpro" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openLineRegister.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("@BeNeatPro")]
                  ),
                  _vm._v(" ค่ะ\n        ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          หมายเหตุ: จำกัดจำนวนที่นั่งต่อรอบ ทางบริษัทขออนุญาตให้สิทธิ์ตามลำดับการแจ้งโอนค่ะ\n        "
                  )
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: "/static/img/beneat-account.jpg", alt: "" }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-md-8 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "row mb-3" }, [
                  _vm._m(23),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-8 col-xs-12" },
                    [
                      [
                        _c("vue-core-image-upload", {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            extensions: "jpg,jpeg,png,gif",
                            crop: false,
                            "max-file-size": 5242880,
                            credentials: false,
                            url: _vm.idCardURL,
                            text: _vm.$t(_vm.isIdCardUploading)
                          },
                          on: {
                            imageuploaded: _vm.uploadedIdCard,
                            imageuploading: _vm.uploadingIdCard,
                            errorhandle: _vm.errorHandle
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-remark mt-1" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "message.bank_transfer.transfer_picture_remark01"
                                )
                              )
                          ),
                          _c("br")
                        ])
                      ],
                      _vm._v(" "),
                      _vm.idCardImageURL
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.idCardImageURL,
                                alt: "สำเนาบัตรประชาชน",
                                width: "300"
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.idCardUploadSuccess
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c("i", {
                              staticClass:
                                "fas fa-check-circle -status-accepted"
                            }),
                            _vm._v(
                              "\n              อัพโหลดไฟล์สำเร็จ\n            "
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _vm._m(24),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-8 col-xs-12" },
                    [
                      [
                        _c("vue-core-image-upload", {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            extensions: "jpg,jpeg,png,gif",
                            crop: false,
                            "max-file-size": 5242880,
                            credentials: false,
                            url: _vm.censusURL,
                            text: _vm.$t(_vm.isCensusUploading)
                          },
                          on: {
                            imageuploaded: _vm.uploadedCensus,
                            imageuploading: _vm.uploadingCensus,
                            errorhandle: _vm.errorHandle
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-remark mt-1" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "message.bank_transfer.transfer_picture_remark01"
                                )
                              )
                          ),
                          _c("br")
                        ])
                      ],
                      _vm._v(" "),
                      _vm.censusImageURL
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.censusImageURL,
                                alt: "สำเนาทะเบียนบ้าน",
                                width: "300"
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.censusUploadSuccess
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c("i", {
                              staticClass:
                                "fas fa-check-circle -status-accepted"
                            }),
                            _vm._v(
                              "\n              อัพโหลดไฟล์สำเร็จ\n            "
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _vm._m(25),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-8 col-xs-12" },
                    [
                      [
                        _c("vue-core-image-upload", {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            extensions: "jpg,jpeg,png,gif",
                            crop: false,
                            "max-file-size": 5242880,
                            credentials: false,
                            url: _vm.slipURL,
                            text: _vm.$t(_vm.isSlipUploading)
                          },
                          on: {
                            imageuploaded: _vm.uploadedSlip,
                            imageuploading: _vm.uploadingSlip,
                            errorhandle: _vm.errorHandle
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-remark mt-1" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "message.bank_transfer.transfer_picture_remark01"
                                )
                              )
                          ),
                          _c("br")
                        ])
                      ],
                      _vm._v(" "),
                      _vm.slipImageURL
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.slipImageURL,
                                alt: "หลักฐานการโอนเงินค่าสมัคร",
                                width: "300"
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.slipUploadSuccess
                        ? _c("div", { staticClass: "mt-2" }, [
                            _c("i", {
                              staticClass:
                                "fas fa-check-circle -status-accepted"
                            }),
                            _vm._v(
                              "\n              อัพโหลดไฟล์สำเร็จ\n            "
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "col-md-8 col-xs-12 mx-auto" }, [
                _vm._m(26),
                _vm._v(" "),
                _c("p", { staticClass: "text-muted" }, [
                  _vm._v(
                    "\n          ** ติดต่อฝ่ายรับสมัคร ได้ที่ไลน์ไอดี @beneatpro (กดแอดไลน์อัตโนมัติ >> "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "https://line.me/R/ti/p/%40beneatpro" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openLineRegister.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("@BeNeatPro")]
                  ),
                  _vm._v(") "),
                  _c("br"),
                  _vm._v("\n          หรือเบอร์โทรติดต่อ "),
                  _c("br"),
                  _vm._v("\n          - เชียงใหม่ 062-5688997"),
                  _c("br"),
                  _vm._v(
                    "\n          - กรุงเทพ ปริมณฑล / จังหวัดอื่น 064-9952288 หรือ 062-2917700\n        "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-md-8 col-xs-12 mx-auto" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button-large button-block -cyan",
                      on: {
                        click: function($event) {
                          return _vm.submitPicture()
                        }
                      }
                    },
                    [_c("label", [_vm._v("ต่อไป")])]
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === 4
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-8 col-xs-12 mx-auto" },
                [
                  _c("h2", [
                    _vm._v("กรุณากรอกข้อมูลเพิ่มเติมในหน้าแบบฟอร์มนี้")
                  ]),
                  _vm._v(" "),
                  _vm.isOtherInfoSaved
                    ? [
                        _c("h3", [
                          _vm._v(
                            "กรุณารอเจ้าหน้าที่ตรวจสอบเอกสารและติดต่อกลับภายใน 24 ชั่วโมงค่ะ"
                          )
                        ])
                      ]
                    : [_vm._m(27)],
                  _vm._v(" "),
                  !_vm.isOtherInfoSaved
                    ? _c("div", [
                        _c("div", { staticClass: "form-group my-4" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.otherInfoSubmitData.nickname,
                                expression: "otherInfoSubmitData.nickname"
                              }
                            ],
                            staticClass: "form-control input-lg",
                            class: { "form-alert": _vm.errors.has("nickName") },
                            attrs: {
                              type: "text",
                              name: "nickName",
                              placeholder: "ชื่อเล่น"
                            },
                            domProps: {
                              value: _vm.otherInfoSubmitData.nickname
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.otherInfoSubmitData,
                                  "nickname",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("nickName")
                            ? _c(
                                "div",
                                {
                                  staticClass: "form-alert-text -status-alert"
                                },
                                [_vm._v("กรุณากรอกชื่อเล่น")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._m(28),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "form-check ml-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.otherInfoSubmitData.religion,
                                  expression: "otherInfoSubmitData.religion"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "religion",
                                id: "religion1",
                                value: "พุทธ"
                              },
                              domProps: {
                                checked: _vm._q(
                                  _vm.otherInfoSubmitData.religion,
                                  "พุทธ"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.otherInfoSubmitData,
                                    "religion",
                                    "พุทธ"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label ml-2",
                                attrs: { for: "religion1" }
                              },
                              [_vm._v("\n                พุทธ\n              ")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check ml-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.otherInfoSubmitData.religion,
                                  expression: "otherInfoSubmitData.religion"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "religion",
                                id: "religion2",
                                value: "คริสต์"
                              },
                              domProps: {
                                checked: _vm._q(
                                  _vm.otherInfoSubmitData.religion,
                                  "คริสต์"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.otherInfoSubmitData,
                                    "religion",
                                    "คริสต์"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label ml-2",
                                attrs: { for: "religion2" }
                              },
                              [
                                _vm._v(
                                  "\n                คริสต์\n              "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check ml-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.otherInfoSubmitData.religion,
                                  expression: "otherInfoSubmitData.religion"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "religion",
                                id: "religion3",
                                value: "อิสลาม"
                              },
                              domProps: {
                                checked: _vm._q(
                                  _vm.otherInfoSubmitData.religion,
                                  "อิสลาม"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.otherInfoSubmitData,
                                    "religion",
                                    "อิสลาม"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label ml-2",
                                attrs: { for: "religion3" }
                              },
                              [
                                _vm._v(
                                  "\n                อิสลาม\n              "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check ml-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.otherInfoSubmitData.religion,
                                  expression: "otherInfoSubmitData.religion"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "religion",
                                id: "religion4",
                                value: "other"
                              },
                              domProps: {
                                checked: _vm._q(
                                  _vm.otherInfoSubmitData.religion,
                                  "other"
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.otherInfoSubmitData,
                                    "religion",
                                    "other"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label ml-2",
                                attrs: { for: "religion4" }
                              },
                              [
                                _vm._v(
                                  "\n                อื่น ๆ\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.otherInfoSubmitData.religion === "other"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.religionOther,
                                      expression: "religionOther"
                                    }
                                  ],
                                  staticClass: "form-control input-md my-2",
                                  class: {
                                    "form-alert": _vm.errors.has(
                                      "religionOther"
                                    )
                                  },
                                  attrs: {
                                    type: "text",
                                    name: "religionOther",
                                    placeholder: "(โปรดระบุ)"
                                  },
                                  domProps: { value: _vm.religionOther },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.religionOther = $event.target.value
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("religionOther")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-alert-text -status-alert"
                                  },
                                  [_vm._v("กรุณาระบุชื่อศาสนา")]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.errors.has("religion")
                            ? _c(
                                "div",
                                {
                                  staticClass: "form-alert-text -status-alert"
                                },
                                [_vm._v("กรุณาระบุศาสนา")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group my-4" }, [
                          _c("label", { attrs: { for: "currentAddress" } }, [
                            _vm._v("ที่อยู่ปัจจุบัน")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.otherInfoSubmitData.current_address,
                                expression:
                                  "otherInfoSubmitData.current_address"
                              }
                            ],
                            ref: "currentAddress",
                            staticClass: "form-control textarea-jumbo",
                            class: {
                              "form-alert": _vm.errors.has("currentAddress")
                            },
                            attrs: {
                              id: "currentAddress",
                              rows: "4",
                              name: "currentAddress"
                            },
                            domProps: {
                              value: _vm.otherInfoSubmitData.current_address
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.otherInfoSubmitData,
                                  "current_address",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("currentAddress")
                            ? _c(
                                "div",
                                {
                                  staticClass: "form-alert-text -status-alert"
                                },
                                [
                                  _vm._v(
                                    "กรุณากรอกที่อยู่ปัจจุบัน\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group my-4" }, [
                          _c("label", { attrs: { for: "address" } }, [
                            _vm._v("ที่อยู่ตามบัตรประชาชน")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.otherInfoSubmitData.address,
                                expression: "otherInfoSubmitData.address"
                              }
                            ],
                            ref: "address",
                            staticClass: "form-control textarea-jumbo",
                            class: { "form-alert": _vm.errors.has("address") },
                            attrs: {
                              id: "address",
                              rows: "4",
                              name: "address"
                            },
                            domProps: {
                              value: _vm.otherInfoSubmitData.address
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.otherInfoSubmitData,
                                  "address",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("address")
                            ? _c(
                                "div",
                                {
                                  staticClass: "form-alert-text -status-alert"
                                },
                                [
                                  _vm._v(
                                    "กรุณากรอกที่อยู่ตามทะเบียนบ้าน\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._m(29),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-3 col-xs-12 pl-0 pr-0",
                              class: {
                                "pr-2": !_vm.$mq.phone,
                                "py-2": _vm.$mq.phone
                              }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.otherInfoSubmitData
                                          .father_prefix_name,
                                      expression:
                                        "otherInfoSubmitData.father_prefix_name"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "form-alert": _vm.errors.has(
                                      "father_prefix_name"
                                    )
                                  },
                                  attrs: { name: "father_prefix_name" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.otherInfoSubmitData,
                                        "father_prefix_name",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("เลือกคำนำหน้าชื่อ")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.prefixName, function(item, index) {
                                    return _c(
                                      "option",
                                      { key: index, domProps: { value: item } },
                                      [_vm._v(_vm._s(item))]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.errors.has("father_prefix_name")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-alert-text -status-alert"
                                    },
                                    [
                                      _vm._v(
                                        "\n                กรุณาเลือกคำนำหน้าชื่อ บิดา\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 col-xs-12 pl-0 pr-0",
                              class: {
                                "pr-2": !_vm.$mq.phone,
                                "py-2": _vm.$mq.phone
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.otherInfoSubmitData.father_firstname,
                                    expression:
                                      "otherInfoSubmitData.father_firstname"
                                  }
                                ],
                                staticClass: "form-control input-lg",
                                class: {
                                  "form-alert": _vm.errors.has(
                                    "fatherFirstName"
                                  )
                                },
                                attrs: {
                                  type: "text",
                                  name: "fatherFirstName",
                                  placeholder: "ชื่อบิดา"
                                },
                                domProps: {
                                  value:
                                    _vm.otherInfoSubmitData.father_firstname
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.otherInfoSubmitData,
                                      "father_firstname",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.errors.has("fatherFirstName")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-alert-text -status-alert"
                                    },
                                    [_vm._v("กรุณากรอกชื่อบิดา")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-5 col-xs-12 pl-0 pr-0",
                              class: { "pl-2": !_vm.$mq.phone }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.otherInfoSubmitData.father_lastname,
                                    expression:
                                      "otherInfoSubmitData.father_lastname"
                                  }
                                ],
                                staticClass: "form-control input-lg",
                                class: {
                                  "form-alert": _vm.errors.has("fatherLastName")
                                },
                                attrs: {
                                  type: "text",
                                  name: "fatherLastName",
                                  placeholder: "นามสกุลบิดา"
                                },
                                domProps: {
                                  value: _vm.otherInfoSubmitData.father_lastname
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.otherInfoSubmitData,
                                      "father_lastname",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.errors.has("fatherLastName")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-alert-text -status-alert"
                                    },
                                    [
                                      _vm._v(
                                        "กรุณากรอกนามสกุลบิดา\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(30),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-3 col-xs-12 pl-0 pr-0",
                              class: {
                                "pr-2": !_vm.$mq.phone,
                                "py-2": _vm.$mq.phone
                              }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.otherInfoSubmitData
                                          .mother_prefix_name,
                                      expression:
                                        "otherInfoSubmitData.mother_prefix_name"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "form-alert": _vm.errors.has(
                                      "mother_prefix_name"
                                    )
                                  },
                                  attrs: { name: "mother_prefix_name" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.otherInfoSubmitData,
                                        "mother_prefix_name",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("เลือกคำนำหน้าชื่อ")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.prefixName, function(item, index) {
                                    return _c(
                                      "option",
                                      { key: index, domProps: { value: item } },
                                      [_vm._v(_vm._s(item))]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.errors.has("mother_prefix_name")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-alert-text -status-alert"
                                    },
                                    [
                                      _vm._v(
                                        "\n                กรุณาเลือกคำนำหน้าชื่อ บิดา\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 col-xs-12 pl-0 pr-0",
                              class: {
                                "pr-2": !_vm.$mq.phone,
                                "py-2": _vm.$mq.phone
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.otherInfoSubmitData.mother_firstname,
                                    expression:
                                      "otherInfoSubmitData.mother_firstname"
                                  }
                                ],
                                staticClass: "form-control input-lg",
                                class: {
                                  "form-alert": _vm.errors.has(
                                    "motherFirstName"
                                  )
                                },
                                attrs: {
                                  type: "text",
                                  name: "motherFirstName",
                                  placeholder: "ชื่อมารดา"
                                },
                                domProps: {
                                  value:
                                    _vm.otherInfoSubmitData.mother_firstname
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.otherInfoSubmitData,
                                      "mother_firstname",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.errors.has("motherFirstName")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-alert-text -status-alert"
                                    },
                                    [_vm._v("กรุณากรอกชื่อมารดา")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-5 col-xs-12 pl-0 pr-0",
                              class: { "pl-2": !_vm.$mq.phone }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.otherInfoSubmitData.mother_lastname,
                                    expression:
                                      "otherInfoSubmitData.mother_lastname"
                                  }
                                ],
                                staticClass: "form-control input-lg",
                                class: {
                                  "form-alert": _vm.errors.has("motherLastName")
                                },
                                attrs: {
                                  type: "text",
                                  name: "motherLastName",
                                  placeholder: "นามสกุลมารดา"
                                },
                                domProps: {
                                  value: _vm.otherInfoSubmitData.mother_lastname
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.otherInfoSubmitData,
                                      "mother_lastname",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.errors.has("motherLastName")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-alert-text -status-alert"
                                    },
                                    [
                                      _vm._v(
                                        "กรุณากรอกนามสกุลมารดา\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(31),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-2" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.otherInfoSubmitData
                                    .emergency_contact_name,
                                expression:
                                  "otherInfoSubmitData.emergency_contact_name"
                              }
                            ],
                            staticClass: "form-control input-lg",
                            attrs: {
                              type: "text",
                              name: "emergencyContactName",
                              placeholder: "ชื่อ-นามสกุล"
                            },
                            domProps: {
                              value:
                                _vm.otherInfoSubmitData.emergency_contact_name
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.otherInfoSubmitData,
                                  "emergency_contact_name",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-2" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.otherInfoSubmitData.emergency_contact_tel,
                                expression:
                                  "otherInfoSubmitData.emergency_contact_tel"
                              }
                            ],
                            staticClass: "form-control input-lg",
                            attrs: {
                              type: "text",
                              name: "emergencyContactTel",
                              placeholder: "เบอร์โทร"
                            },
                            domProps: {
                              value:
                                _vm.otherInfoSubmitData.emergency_contact_tel
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.otherInfoSubmitData,
                                  "emergency_contact_tel",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-4 form-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button-large button-block -cyan",
                              on: {
                                click: function($event) {
                                  return _vm.submitOtherInformation()
                                }
                              }
                            },
                            [_c("label", [_vm._v("บันทึก")])]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted mt-4" }, [
                    _vm._v(
                      "\n          ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครที่"
                    ),
                    _c("br"),
                    _vm._v("\n          - เชียงใหม่ติดต่อ 062-5688997"),
                    _c("br"),
                    _vm._v(
                      "\n          - กรุงเทพ ปริมณฑล และจังหวัดอื่น ๆ ติดต่อ 064-9952288 หรือ 062-2917700"
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v("\n          Line ID: "),
                    _c(
                      "a",
                      {
                        attrs: { href: "https://line.me/R/ti/p/%40beneatpro" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openLineRegister.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("@BeNeatPro")]
                    )
                  ])
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === 5
        ? _c("div", [
            _vm.trainingInfo
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-8 col-xs-12 mx-auto" },
                    [
                      _c("h2", { staticClass: "text-align: center;" }, [
                        _vm._v("การจองเข้าอบรมเสร็จสมบูรณ์แล้ว")
                      ]),
                      _vm._v(" "),
                      _c("h3", [_vm._v("วันที่ฝึกอบรม:")]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "ml-4" }, [
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm._f("prettyOnlyDate")(_vm.trainingInfo.date)
                            ) +
                              "\n            " +
                              _vm._s(
                                "(" +
                                  _vm.trainingInfo.start_time +
                                  " - " +
                                  _vm.trainingInfo.end_time +
                                  ")"
                              ) +
                              "\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("h3", [_vm._v("สถานที่ฝึกอบรม:")]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "ml-4" }, [
                        _c("li", [
                          _c(
                            "p",
                            { staticStyle: { "white-space": "pre-wrap" } },
                            [
                              _vm._v(
                                _vm._s(_vm.trainingInfo.training_center.address)
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n            โปรดแต่งกายสุภาพ กรุณาสวมเสื้อสีเข้ม (ดำ หรือ กรม) รบกวนสวมรองเท้าหุ้มส้นหรือรองเท้าผ้าใบค่ะ\n            กรุณานำถุงมือยางแบบหนายาวมาด้วย 1 คู่ พร้อมกับหน้ากากอนามัย และชุดตรวจ ATK ค่ะ\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "background-color": "#92d7ef",
                            padding: "1rem"
                          }
                        },
                        [
                          _c("h3", [_vm._v("กรุณาดำเนินการดังต่อไปนี้:")]),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(
                              "1. ท่านต้องการให้ BeNeat ช่วยอำนวยความสะดวกในการตรวจสอบประวัติอาชญากรรมให้หรือไม่?"
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check ml-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.criminalHistoryHelper,
                                  expression: "criminalHistoryHelper"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "criminalHistoryHelper",
                                id: "criminalHistoryHelper1"
                              },
                              domProps: {
                                value: 1,
                                checked: _vm._q(_vm.criminalHistoryHelper, 1)
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.criminalHistoryHelper = 1
                                  },
                                  _vm.submitCriminalHistoryHelper
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label ml-2",
                                attrs: { for: "criminalHistoryHelper1" }
                              },
                              [
                                _vm._v(
                                  "\n              ต้องการให้ BeNeat ดำเนินการให้ (โปรดเตรียมค่าใช้จ่าย 150 บาทมาในวันฝึกอบรม)\n            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-check ml-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.criminalHistoryHelper,
                                  expression: "criminalHistoryHelper"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "criminalHistoryHelper",
                                id: "criminalHistoryHelper2"
                              },
                              domProps: {
                                value: 0,
                                checked: _vm._q(_vm.criminalHistoryHelper, 0)
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.criminalHistoryHelper = 0
                                  },
                                  _vm.submitCriminalHistoryHelper
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label ml-2",
                                attrs: { for: "criminalHistoryHelper2" }
                              },
                              [
                                _vm._v(
                                  "\n              ท่านจะดำเนินการด้วยตนเอง (โปรดติดต่อสำนักงานตำรวจแห่งชาติ ค่าใช้จ่าย 100 บาท)\n            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.criminalHistoryHelper === 0
                            ? _c("div", { staticClass: "row mt-2" }, [
                                _vm._m(32)
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h4", { staticClass: "mt-2" }, [
                            _vm._v(
                              "2. โปรดอัพโหลดหน้าสมุดบัญชีธนาคารกสิกร (หากยังไม่มีของธนาคารกสิกร กรุณาแจ้งเจ้าหน้าที่ฝ่ายรับสมัครทางไลน์ @beneatpro ค่ะ)"
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mb-3" }, [
                            _vm._m(33),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8 col-xs-12" },
                              [
                                [
                                  _c("vue-core-image-upload", {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      extensions: "png,jpeg,jpg",
                                      crop: false,
                                      "max-file-size": 5242880,
                                      credentials: false,
                                      url: _vm.bookBankURL,
                                      text: _vm.$t(_vm.isBookBankUploading)
                                    },
                                    on: {
                                      imageuploaded: _vm.uploadedBookBank,
                                      imageuploading: _vm.uploadingBookBank,
                                      errorhandle: _vm.errorHandle
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-remark mt-1" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.bank_transfer.transfer_picture_remark01"
                                            )
                                          )
                                      ),
                                      _c("br")
                                    ]
                                  )
                                ],
                                _vm._v(" "),
                                _vm.bookBankUploadSuccess
                                  ? _c("div", { staticClass: "mt-2" }, [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-check-circle -status-accepted"
                                      }),
                                      _vm._v(
                                        "\n                อัพโหลดไฟล์สำเร็จ\n              "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "mt-2" }, [
                            _vm._v(
                              "3. กรุณาติดตั้ง Application นี้ในมือถือเพื่อความรวดเร็วในการฝึกอบรม"
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(34)
                        ]
                      ),
                      _vm._v(" "),
                      _vm.videoURL
                        ? [
                            _c("div", { staticClass: "video-wrapper mt-4" }, [
                              _c("iframe", {
                                attrs: {
                                  src: _vm.videoURL,
                                  width: "640",
                                  height: "360",
                                  frameborder: "0",
                                  webkitallowfullscreen: "",
                                  mozallowfullscreen: "",
                                  allowfullscreen: ""
                                }
                              })
                            ])
                          ]
                        : [
                            _c("div", { staticClass: "mt-4" }, [
                              _c("p", [
                                _vm._v(
                                  "กรุณาใส่รหัส 12345 เพื่อเข้ารับชมวิดีโอค่ะ"
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.videoPassword,
                                      expression: "videoPassword"
                                    }
                                  ],
                                  staticClass: "form-control input-lg",
                                  class: {
                                    "form-alert": _vm.errors.has(
                                      "videoPassword"
                                    )
                                  },
                                  attrs: {
                                    type: "password",
                                    name: "videoPassword",
                                    placeholder: "รหัส"
                                  },
                                  domProps: { value: _vm.videoPassword },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.videoPassword = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.errors.has("videoPassword")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-alert-text -status-alert"
                                      },
                                      [_vm._v("กรุณากรอกรหัส")]
                                    )
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button-large button-block -cyan",
                                  on: {
                                    click: function($event) {
                                      return _vm.summitVideoPass()
                                    }
                                  }
                                },
                                [_c("label", [_vm._v("ยืนยันรหัส")])]
                              )
                            ])
                          ],
                      _vm._v(" "),
                      _c("p", { staticClass: "text-muted mt-2" }, [
                        _vm._v(
                          "\n          ** หากต้องการความช่วยเหลือหรือสอบถามรายละเอียดเพิ่มเติม กรุณาติดต่อฝ่ายรับสมัครที่"
                        ),
                        _c("br"),
                        _vm._v("\n          - เชียงใหม่ติดต่อ 062-5688997"),
                        _c("br"),
                        _vm._v(
                          "\n          - กรุงเทพ ปริมณฑล และจังหวัดอื่น ๆ ติดต่อ 064-9952288 หรือ 062-2917700"
                        ),
                        _c("br"),
                        _c("br"),
                        _vm._v("\n          Line ID: "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://line.me/R/ti/p/%40beneatpro"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.openLineRegister.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v("@BeNeatPro")]
                        )
                      ])
                    ],
                    2
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("pdpa-consent-modal", { ref: "pdpaConsentModal" })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label ml-2",
        attrs: { for: "accept_protect_personal_information" }
      },
      [
        _vm._v(
          "\n              ยอมรับเงื่อนไขนโยบายคุ้มครองข้อมูลส่วนบุคคลและยินยอมให้เปิดเผยข้อมูลส่วนบุคคล "
        ),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              download: "",
              href:
                "/static/pdf/เอกสารแสดงความยินยอมให้เปิดเผยข้อมูลส่วนบุคคล_beneat.pdf"
            }
          },
          [_vm._v("ดูเพิ่มเติม")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4 col-xs-12 my-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/static/img/training00.jpg", alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4 col-xs-12 my-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/static/img/training01.jpg", alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4 col-xs-12 my-3" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/static/img/training02.jpg", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
        _c("h3", [_vm._v("ข้อมูลทั่วไป")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 p-0" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("วันเกิด")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group mt-4" }, [
      _c("div", { staticClass: "mt-2" }, [
        _c("h4", [_vm._v("ท่านทราบข่าวการรับสมัครคุณแม่บ้านบีนีทจากที่ไหน")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("label", [
        _vm._v("ประเภทของงานที่ต้องการให้บริการ (เลือกได้มากกว่า 1 ข้อ)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("label", [_vm._v("ท่านสนใจงานทำความสะอาดแบบประจำด้วยหรือไม่ ?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("label", [
        _vm._v(
          "เคยทำอาชีพเกี่ยวกับทำความสะอาดหรือกำลังทำอาชีพนี้อยู่ในปัจจุบันหรือไม่ ?"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("label", [_vm._v("ปัจจุบันท่านสูบบุหรี่หรือไม่ ?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("label", [_vm._v("ปัจจุบันท่านดื่มแอลกอฮอล์หรือไม่ ?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
        _c("h3", [_vm._v("แบบสอบถาม")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto" }, [
        _c("h4", [_vm._v("1. เคยมีอาชีพแม่บ้านหรือพนักงานทำความสะอาดหรือไม่")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto mt-2" }, [
        _c("h4", [_vm._v("2. ประสบการณ์ทำความสะอาดที่พัก")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto mt-2" }, [
        _c("h4", [
          _vm._v("3. ประเภทที่พักที่เคยทำความสะอาด (เลือกได้มากกว่า 1 ข้อ)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto mt-2" }, [
        _c("h4", [
          _vm._v(
            "4. ท่านเคยมีประสบการณ์งานทำความสะอาดผ่านบริษัทหรือแอพอื่นมาก่อนหรือไม่"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto mt-2" }, [
        _c("h4", [_vm._v("5. ช่วงเวลาที่สะดวกรับงาน")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto mt-2" }, [
        _c("h4", [
          _vm._v("6. ภาษาที่ท่านสามารถสื่อสารได้ (เลือกได้มากกว่า 1 ข้อ)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto mt-2" }, [
        _c("h4", [_vm._v("7. ประสบการทำงานด้านอื่นๆ (เลือกได้มากกว่า 1 ข้อ)")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("div", { staticClass: "col-md-6 col-xs-12 mx-auto mt-2" }, [
        _c("h4", [_vm._v("8. ความสามารถในการขับขี่ยานพาหนะ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video-wrapper" }, [
      _c("iframe", {
        attrs: {
          src: "https://player.vimeo.com/video/309827107",
          width: "640",
          height: "360",
          frameborder: "0",
          webkitallowfullscreen: "",
          mozallowfullscreen: "",
          allowfullscreen: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video-wrapper" }, [
      _c("iframe", {
        attrs: {
          width: "560",
          height: "315",
          src: "https://www.youtube.com/embed/XgnuTLmSHcA",
          frameborder: "0",
          allow: "autoplay; encrypted-media",
          allowfullscreen: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("iframe", {
        attrs: {
          src: "https://www.tiktok.com/embed/7408368962855030023",
          width: "600",
          height: "800",
          frameborder: "0",
          allowfullscreen: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 col-xs-12 mx-auto" }, [
        _c("div", { staticClass: "video-wrapper" }, [
          _c("iframe", {
            attrs: {
              src: "https://player.vimeo.com/video/325400198",
              width: "640",
              height: "360",
              frameborder: "0",
              webkitallowfullscreen: "",
              mozallowfullscreen: "",
              allowfullscreen: ""
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("สำเนาบัตรประชาชน")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("สำเนาทะเบียนบ้าน")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("หลักฐานการโอนเงินค่าสมัคร")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-muted" }, [
      _vm._v(
        "\n          *หากท่านยังไม่สะดวกจัดเตรียมเอกสาร สามารถอัพโหลดเอกสารในภายหลัง "
      ),
      _c("br"),
      _vm._v("\n          เพียงแค่คลิกที่ลิงก์สมัครแล้วกรอกเลขบัตรประชาชน "),
      _c("br"),
      _vm._v(
        "\n          ระบบจะนําท่านเข้าสู่หน้านี้โดยอัตโนมัติให้อัพโหลดได้ค่ะหรือสามารถส่งเอกสารพร้อมสลิปให้เจ้าหน้าที่ทางไลน์ไอดี\n          @beneatpro ค่ะ\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("เพื่อให้เจ้าหน้าที่จัดเตรียมข้อมูลในระบบสำหรับการเข้าอบรมงาน "),
      _c("br"),
      _vm._v(
        "\n            ***ข้อมูลของบิดาและมารดา ใช้เป็นข้อมูลในการส่งตรวจประวัติอาชญากรรม "
      ),
      _c("br"),
      _vm._v(
        "\n            หากท่านใดไปตรวจเองแล้วไม่จำเป็นต้องกรอกค่ะ ให้ใส่เครื่องหมาย - ได้เลยค่ะ"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [_c("label", [_vm._v("ศาสนา")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("label", [_vm._v("ชื่อ-นามสกุล บิดา")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("label", [_vm._v("ชื่อ-นามสกุล มารดา")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("label", [
        _vm._v(
          "ชื่อ-นามสกุลและเบอร์โทรติดต่อของบุคคลใกล้ชิดที่ทาง BeNeat สามารถติดต่อได้หากมีกรณีฉุกเฉิน"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body pl-5" }, [
        _c("ol", [
          _c("li", [
            _vm._v(
              "ผู้สมัครสามารถยื่นตรวจประวัติอาชญากรรมได้ที่สำนักงานตำรวจแห่งชาติ จะได้รับผลตรวจภายในวันเดียวกัน"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("เตรียมค่าธรรมเนียมการตรวจ 100 บาท")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("ใช้เอกสารคือบัตรประจำตัวประชาชน (นำสำเนาไปเผื่อด้วยค่ะ)")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "ให้แจ้งว่าขอตรวจประวัติเพื่อนำไปสมัครงาน (ไม่แจ้งว่าบริษัทให้มาตรวจนะคะ เพราะขั้นตอนจะยุ่งยาก และผู้สมัครไม่ได้เป็นพนักงานของบริษัทค่ะ)"
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("หน้าสมุดบัญชีธนาคาร")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "ml-4" }, [
      _c("li", [
        _vm._v("BeNeat Cleaner: "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://play.google.com/store/apps/details?id=com.beneat.android",
              target: "_blank"
            }
          },
          [_vm._v("Android")]
        ),
        _vm._v(", "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://itunes.apple.com/th/app/beneat-cleaner/id1323965255",
              target: "_blank"
            }
          },
          [_vm._v("iOS")]
        ),
        _vm._v(
          "\n              (ติดตั้งไว้ก่อนแต่ยังไม่ต้องทำอะไรค่ะ)\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64a5d812", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a5d812","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/ProfessionalRegister.vue
// module id = 2003
// module chunks = 0